import React from 'react';
import { PropTypes } from 'prop-types';
import { DayPickerInput as CoreDayPickerInput } from '@ipc/ipc-components';
import { formatDate, parseDate } from '../../utils/date';

const DayPickerInput = ({
  name, value, onChange, disabled, dayPickerProps,
}) => (
  <div className="StyledDateInput">
    <CoreDayPickerInput
      placeholder="DD/MM/YYYY"
      formatDate={formatDate}
      parseDate={parseDate}
      onDayChange={onChange}
      format="DD/MM/YYYY"
      name={name}
      value={value}
      dayPickerProps={dayPickerProps}
      inputProps={{ disabled }}
    />
  </div>
);

DayPickerInput.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  disabled: PropTypes.bool,
  dayPickerProps: PropTypes.shape(),
};

export default DayPickerInput;
